import React, { useEffect, useState } from "react";
import connect from "react-redux/es/connect/connect";
import { FormattedMessage } from "react-intl";

// @mui/icons-material
import { ErrorOutline } from "@mui/icons-material";

// core components
import Snackbar from "components/snackbar/snackbar";

// the code raised by the API when a category still mapped to a retailer feed
// is deleted (its ON DELETE CASCADE would orphan the products otherwise)
const MAPPED_ERROR_CODE = "CATEGORY_MAPPED_CANNOT_BE_DELETED";

function DeleteErrorNotification({ deleteError, deleteSelectionError }) {
    const [open, setOpen] = useState(false);
    const error = deleteError || deleteSelectionError;

    useEffect(() => {
        if (deleteError || deleteSelectionError) {
            setOpen(true);
        }
    }, [deleteError, deleteSelectionError]);

    if (!error) {
        return null;
    }

    const messageId = MAPPED_ERROR_CODE === error
        ? "category.delete.error.mapped"
        : "category.delete.error.generic";

    return (
        <Snackbar
            open={open}
            closeNotification={() => setOpen(false)}
            place={"bl"}
            color={"danger"}
            icon={() => <ErrorOutline />}
            close
            message={<FormattedMessage id={messageId} />}
        />
    );
}

const mapStateToProps = (state) => {
    return {
        deleteError: state.category.deleteCategory.error,
        deleteSelectionError: state.category.deleteSelection.error,
    };
};

export default connect(
    mapStateToProps,
    null
)(DeleteErrorNotification);
